import React from "react";

const ProfileCardSkeleton = () => (
  <div className="border border-gray-300 dark:border-gray-600 rounded-xl p-4 w-full bg-primary-foreground shadow-sm animate-pulse">
    <div className="space-y-3">
      {/* Header Icons and Title */}
      <div className="flex items-center justify-between gap-2">
        <div className="w-60 h-5 rounded-full bg-gray-400 dark:bg-gray-600"></div>
        <div className="h-5 w-3/5 rounded-full bg-gray-400 dark:bg-gray-600"></div>
        <div className="w-40 h-5 rounded-full bg-gray-400 dark:bg-gray-600"></div>
      </div>

      {/* Client Name */}
      <div className="h-5 w-2/5 rounded bg-gray-400 dark:bg-gray-600"></div>

      {/* Sheet Count */}
      <div className="h-5 w-1/2 rounded bg-gray-400 dark:bg-gray-600"></div>

      {/* Date */}
      <div className="h-5 w-3/4 rounded bg-gray-400 dark:bg-gray-600"></div>
    </div>
  </div>
);

export default ProfileCardSkeleton;
